import React, { useMemo } from 'react';
import { View } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import useColors from 'hooks/useColors';
export const NewFreeTrialStepView = ({ icon, title, white, description, first = false, last = false, longAbsLine = false, isMicroModal, }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const colorObj = useMemo(() => {
        const iconContainerColor = white
            ? colors.elements.frostedOnBrand
            : colors.background.dark;
        const firstIconContainerColor = white
            ? colors.text.whiteOnColor
            : colors.elements.brand;
        return {
            lineContainer: white
                ? colors.elements.frostedOnBrand
                : colors.background.dark,
            firstColor: white ? colors.text.whiteOnColor : colors.elements.brand,
            iconContainer: first ? firstIconContainerColor : iconContainerColor,
        };
    }, [
        colors.background.dark,
        colors.elements.frostedOnBrand,
        colors.elements.brand,
        colors.text.whiteOnColor,
        first,
        white,
    ]);
    return (<View id="newFreeTrialView">
      <View style={[
            styles.absLineContainer,
            last && styles.lastAbsLineContainer,
            first && styles.firstAbsLineContainer,
            longAbsLine && styles.longAbsLine,
            { backgroundColor: colorObj.lineContainer },
        ]}>
        {first ? (<View style={[
                styles.firstFilledLine,
                { backgroundColor: colorObj.firstColor },
            ]}/>) : null}
      </View>
      <View style={[
            isMicroModal ? styles.containerMicroModal : styles.container,
            first && styles.firstContainer,
        ]}>
        <View style={[
            styles.iconContainer,
            {
                backgroundColor: colorObj.iconContainer,
            },
        ]}>
          {icon}
        </View>
        <Spacer.W16 />
        <View style={styles.textContainer}>
          <Text Text-16 {...(white && { White: true })}>
            {title}
          </Text>
          <Text TextThin-14 {...(white ? { White: true } : { Secondary: true })}>
            {description}
          </Text>
        </View>
      </View>
    </View>);
};
const styleSet = createStyleSheets(() => ({
    container: {
        marginTop: rem(24),
        flexDirection: 'row',
    },
    containerMicroModal: {
        marginTop: rem(20),
        flexDirection: 'row',
    },
    firstContainer: {
        marginTop: 0,
    },
    textContainer: {
        flex: 1,
        minHeight: rem(66),
    },
    iconContainer: {
        width: rem(44),
        height: rem(44),
        alignItems: 'center',
        borderRadius: rem(44),
        justifyContent: 'center',
    },
    absLineContainer: {
        top: 0,
        bottom: 0,
        left: rem(18),
        width: rem(8),
        position: 'absolute',
    },
    firstAbsLineContainer: {
        top: rem(22),
    },
    lastAbsLineContainer: {
        borderBottomEndRadius: rem(100),
        borderBottomStartRadius: rem(100),
    },
    longAbsLine: {
        bottom: rem(-24),
    },
    firstFilledLine: {
        flex: 1,
        borderRadius: rem(100),
    },
}));
